import { useTranslation } from "react-i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import { useDispatch, useSelector } from "react-redux";
import { getClassName } from "../../../../../../components/Converter";
import Millimetre from "../../../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../../../components/RowValue/RowBody";
import ToolTip, { IconType } from "../../../../../../components/ToolTip";
import { decimalSeparator, thousandSeparator } from "../../../../../../i18n";
import {
  selectVerpresskoerperdurchmesser,
  setVerpresskoerperdurchmesser,
} from "../../../../../../store/slices/innereSlice";

function Verpresskoerperdurchmesser() {
  const { t } = useTranslation("translation");

  const Verpresskoerperdurchmesser_Formula = `\\displaystyle D_c = D + a_{_{min}}`;

  const dispatch = useDispatch();
  const verpresskoerperdurchmesser = useSelector(selectVerpresskoerperdurchmesser);

  return (
    <RowBody
      titleValue={<p>{t("inner.buckling.ofner.parameterGroutingBody.groutBody")}</p>}
      indicesValue={
        <span>
          D<sub>c</sub>
        </span>
      }
      inputValue={
        <NumberFormat
          className={getClassName(verpresskoerperdurchmesser)}
          value={verpresskoerperdurchmesser}
          decimalSeparator={decimalSeparator()}
          thousandSeparator={thousandSeparator()}
          displayType="input"
          type="text"
          onValueChange={(value) => dispatch(setVerpresskoerperdurchmesser(value.floatValue))}
          allowNegative={true}
        />
      }
      unitValue={<Millimetre />}
      formulaValue={
        <ToolTip
          id={"Verpresskoerperdurchmesser"}
          type={IconType.FORMULA}
          formula={Verpresskoerperdurchmesser_Formula}
        />
      }
    />
  );
}

export default Verpresskoerperdurchmesser;
